import React, { createContext, useContext, ReactNode } from "react";

interface ThemeColorContextValue {
  themeColor: string;
  setThemeColor: (color: string) => void;
}

const ThemeColorContext = createContext<ThemeColorContextValue | null>(null);

type ThemeColorProviderProps = Readonly<{
  children: ReactNode;
  themeColor: string;
  setThemeColor: (color: string) => void;
}>;

export function ThemeColorProvider({
  children,
  themeColor,
  setThemeColor,
}: ThemeColorProviderProps) {
  const value = React.useMemo(
    () => ({ themeColor, setThemeColor }),
    [themeColor, setThemeColor]
  );
  return (
    <ThemeColorContext.Provider value={value}>
      {children}
    </ThemeColorContext.Provider>
  );
}

export function useThemeColor(): ThemeColorContextValue | null {
  return useContext(ThemeColorContext);
}
